var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ButtonAFY, ModalComponentAFY, sizes, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
import { ButtonsContainer, Description, Title, useStyles } from "../style";
export var ModalDelete = function (props) {
    var classes = useStyles();
    return (_jsx(ModalComponentAFY, __assign({ openModal: props.openModalConfirmDelete, backgroundColor: "#ffffff", onClose: function () {
            props.setOpenModalDelete(false);
        }, border: 0, minWidthModal: "500px", padding: 30 }, { children: _jsxs("div", __assign({ style: { marginTop: "10px" } }, { children: [_jsxs(Title, { children: ["Eliminar ", props.modalTitle] }), _jsxs(Description, { children: ["\u00BFEst\u00E1 seguro que desea eliminar ", _jsx("strong", { children: props.modalTitle }), "?"] }), _jsxs(ButtonsContainer, { children: [_jsx("div", __assign({ className: classes.button }, { children: _jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, label: "No", onClick: function () {
                                    props.setOpenModalDelete(false);
                                } }) })), _jsx("div", __assign({ className: classes.button }, { children: _jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, label: "Si, eliminar", backgroundColor: "red", onClick: function (e) {
                                    e.stopPropagation();
                                    props.onClickDelete();
                                } }) }))] })] })) })));
};
